<script>

import CommonSubtitle from "../../CommonSubtitle/index.vue";
import CustomTextField from "../../CustomInput/CustomTextField.vue";
import CustomTextDropdown from "../../CustomInput/CustomDropdown.vue";
import CustomCheckbox from "../../global/CustomCheckBox/CheckBox.vue";
import CustomSelect from "../../global/CustomSelect/index.vue";
import {Educations} from "../../../utils/constants";
import CustomCheckboxGroup from "../../global/CustomCheckBox/CheckBoxGroup.vue";
import {mapState} from "vuex";

export default {
  name: "EmploymentInfo",
  components: {CustomCheckboxGroup, CustomCheckbox, CustomSelect, CustomTextDropdown, CustomTextField, CommonSubtitle},
  props: {
    employmentInfo: {
      type: Object,
      required: true
    },
    v$: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      educations: Educations.map(item => ({id: item.id, label: item.name})),
      selectedEmploymentTypes: [],
      employmentTypes: [
        {name: this.$t('kyc.employment_status_option.1'), value: '1'},
        {name: this.$t('kyc.employment_status_option.2'), value: '2'},
        {name: this.$t('kyc.employment_status_option.3'), value: '3'},
        {name: this.$t('kyc.employment_status_option.9'), value: '9'},
        {name: this.$t('kyc.employment_status_option.10'), value: '10'},
        {name: this.$t('kyc.employment_status_option.11'), value: '11'},
        {name: this.$t('kyc.employment_status_option.8'), value: '8'},
      ],
      educationLevel: null,
    }
  },
  computed: {
    ...mapState('user', ['user']),
  },
  mounted() {
  const employment = this.user?.employments
  if (employment) {
    if (employment.education_level)
      this.educationLevel = employment.education_level.toString()
    if (this.educationLevel == 0)
      this.employmentInfo.education_level_text = employment.education_level_text
    if (employment.profession)
      this.employmentInfo.profession = employment.profession
    if (employment.employment_status)
      this.selectedEmploymentTypes = [employment.employment_status]
    if (employment.employment_status_text)
      this.employmentInfo.employment_status_text = employment.employment_status_text
    if (employment.employer_name) {
      this.employmentInfo.employer_name = employment.employer_name
      if (employment.employer_segment)
        this.employmentInfo.employer_segment = employment.employer_segment
      this.employmentInfo.position = employment.position
      this.employmentInfo.employer_phone = employment.employer_phone
      this.employmentInfo.employer_address = employment.employer_address
    }
  }
},
  watch: {
    selectedEmploymentTypes() {
      this.employmentInfo.employment_status = this.selectedEmploymentTypes.join(';')
    },
    educationLevel() {
      this.employmentInfo.education_level = this.educationLevel
    },
  }
}
</script>

<template>
  <div>
    <CommonSubtitle :name="$t('kyc.employment')"/>
    <div class="ml-4 mr-4">
      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
          <CustomSelect
              :label="$t('kyc.education')"
              v-model="educationLevel"
              :options="educations"
              :error="v$?.education_level.$error"
          />
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4" v-if="educationLevel == 0">
          <CustomTextField
              :label="$t('helper.others')"
              v-model="employmentInfo.education_level_text"
              :error="v$?.education_level_text.$error"
          />
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
          <CustomTextField
              :label="$t('kyc.profession')"
              v-model="employmentInfo.profession"
              :error="v$?.profession.$error"
          />
        </div>
      </div>
      <h5 class="kyc-sub-title">{{ $t('kyc.employment_status') }}</h5>
      <div class="mb-2">
        <CustomCheckboxGroup v-model="selectedEmploymentTypes"
                             :options="employmentTypes"
                             :multiple="false"
                             :error="v$.employment_status.$error"
        >
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 ml-auto mt-1" v-if="selectedEmploymentTypes.includes('11')">
            <CustomTextField
                :label="$t('helper.others')"
                v-model="employmentInfo.employment_status_text"
                :error="v$?.employment_status_text.$error"
            />
          </div>
        </CustomCheckboxGroup>
        <p v-if="v$?.employment_status.$error" class="error-message">{{ $t('kyc.at_least_one') }}</p>
      </div>
      <template v-if="!(selectedEmploymentTypes.includes('8') || selectedEmploymentTypes.includes('10')) ">
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <CustomTextField
                :label="$t('kyc.employer_name')"
                v-model="employmentInfo.employer_name"
                :error="v$?.employer_name.$error"
            />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <CustomTextField
                :label="$t('kyc.employer_segment')"
                v-model="employmentInfo.employer_segment"
                :error="v$?.employer_segment.$error"
            />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <CustomTextField
                :label="$t('kyc.position')"
                v-model="employmentInfo.position"
                :error="v$?.position.$error"
            />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <CustomTextField
                :label="$t('kyc.employer_phone')"
                v-model="employmentInfo.employer_phone"
                :error="v$?.employer_phone.$error"
            />
          </div>
          <div class="col-sm-24 col-md-12 col-lg-8 col-xl-8">
            <CustomTextField
                :label="$t('kyc.employer_address')"
                v-model="employmentInfo.employer_address"
                :error="v$?.employer_address.$error"
            />
          </div>
        </div>
      </template>
    </div>
<!--    <CustomCheckbox v-model="employmentInfo.unemployed" :label="$t('kyc.unemployed')" class="ml-4 mb-4"/>-->
  </div>
</template>

<style scoped lang="scss">
</style>
